import React, { Component } from 'react';
import KnowledgeList from './KnowledgeList';
import KnowledgeDetail from './KnowledgeDetail';

export default class Know extends Component {
    constructor(props) {
        super(props);
        // initialArticle：从 home 的帮助文章条目直达时由 widget 传入 —— 挂载即渲染
        // 详情，绝不先渲染一帧列表（那正是"点文章却跳到列表页"的观感来源）。
        const initial = props.initialArticle || null;
        this.state = {
            view: initial ? 'detail' : 'list', // 'list' or 'detail'
            selectedArticle: initial,
            lastNav: null, // 'push'（进详情）| 'back'（返回列表）—— 控制方向动画，初始/重置不播
            // 来路：'home' 表示这篇详情是从 home 点进来的，返回要回 home 而不是列表。
            // 写死"返回=列表"会把用户丢到他根本没去过的页面。
            returnTo: initial ? (props.initialReturnTo || null) : null,
        };
        // nested 档的列表有自己的两层导航（分类列表 ↔ 分类下文章列表），
        // Help tab 被点时要把它一并复位到落地页。
        this.listRef = React.createRef();
    }

    componentDidMount() {
        // 直接以详情态挂载时补发一次 —— 让 widget 的尺寸模型（详情档 580×860）
        // 与实际视图对齐，不依赖调用方一定预先设过 _knowView。
        if (this.state.view === 'detail' && this.props.onViewChange) {
            this.props.onViewChange('detail');
        }
    }

    // 打开某篇文章的详情。opts.returnTo 记住来路（'home' | null）。
    openArticle = (article, opts = {}) => {
        this.setState({
            view: 'detail',
            selectedArticle: article,
            lastNav: 'push',
            returnTo: opts.returnTo || null,
        });
        if (this.props.onViewChange) {
            this.props.onViewChange('detail');
        }
    }

    // 列表里点进来的详情：来路就是列表，返回回列表
    handleArticleClick = (article) => {
        this.openArticle(article, { returnTo: null });
    }

    handleBack = () => {
        const { returnTo } = this.state;
        // 先把自己复位成列表（下次开 Help tab 是干净的列表 + 面板尺寸回常规档），
        // 再交还给来路。
        this.setState({
            view: 'list',
            selectedArticle: null,
            lastNav: returnTo === 'home' ? null : 'back',
            returnTo: null,
        });

        // Notify parent to change back to list view
        if (this.props.onViewChange) {
            this.props.onViewChange('list');
        }

        // 从 home 进来的 → 回 home，不要停在知识库列表
        if (returnTo === 'home' && this.props.onExit) {
            this.props.onExit('home');
        }
    }

    // 重置到列表视图
    resetToList = () => {
        // 列表自身的层级也要复位 —— nested 档下"上次停在某个分类的文章列表"不该
        // 成为下一次打开 Help tab 的落地页。这一步无条件执行，不能被下面
        // `view !== 'list'` 的早退挡掉（已经在 list 上时正是最常见的情形）。
        if (this.listRef.current && this.listRef.current.resetToRoot) {
            this.listRef.current.resetToRoot();
        }
        if (this.state.view !== 'list') {
            this.setState({
                view: 'list',
                selectedArticle: null,
                lastNav: null,
                returnTo: null,
            });

            // Notify parent to change back to list view
            if (this.props.onViewChange) {
                this.props.onViewChange('list');
            }
        }
    }

    _reducedMotion = () => {
        try { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
    }

    render() {
        const { view, selectedArticle, lastNav } = this.state;
        const { appId, theme } = this.props;
        const reduced = this._reducedMotion();

        // 列表保持挂载（display:none）：返回时不重新拉数据、滚动位置原地保留。
        // 之前进详情就卸载列表 → 返回后列表回顶 + 重新 loading，「返回」形同重进。
        // 进出场沿用 widget 全局的 lcViewPush/Pop keyframes（方向感知：详情=push，返回=pop）。
        return (
            <div style={{ width: '100%', height: '100%', position: 'relative', overflow: 'hidden' }}>
                <div style={{
                    display: view === 'list' ? 'block' : 'none',
                    width: '100%', height: '100%',
                    ...(view === 'list' && lastNav === 'back' && !reduced ? { animation: 'lcViewPopA var(--lc-dur-base) var(--lc-ease-out)' } : {}),
                }}>
                    <KnowledgeList
                        ref={this.listRef}
                        appId={appId}
                        theme={theme}
                        layoutMode={this.props.kbLayoutMode || 'auto'}
                        onArticleClick={this.handleArticleClick}
                    />
                </div>
                {view === 'detail' && selectedArticle && (
                    <div style={{
                        width: '100%', height: '100%',
                        ...(reduced ? {} : { animation: 'lcViewPushA var(--lc-dur-base) var(--lc-ease-out)' }),
                    }}>
                        <KnowledgeDetail
                            article={selectedArticle}
                            theme={theme}
                            appConfig={this.props.appConfig}
                            onBack={this.handleBack}
                        />
                    </div>
                )}
            </div>
        );
    }
}
